import { render, staticRenderFns } from "./ezpay-index.vue?vue&type=template&id=2ddc110c&scoped=true"
import script from "./ezpay-index.vue?vue&type=script&lang=js"
export * from "./ezpay-index.vue?vue&type=script&lang=js"
import style0 from "./ezpay-index.vue?vue&type=style&index=0&id=2ddc110c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc110c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ddc110c')) {
      api.createRecord('2ddc110c', component.options)
    } else {
      api.reload('2ddc110c', component.options)
    }
    module.hot.accept("./ezpay-index.vue?vue&type=template&id=2ddc110c&scoped=true", function () {
      api.rerender('2ddc110c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/ezpay-index.vue"
export default component.exports